import { DatosPago, MedioPagoReq, MetodoPago } from '../../types/Pago/types';
import { apiRequest } from '../Utils/apiClient';
import { DATOS_PAGO, GET_PAYMENT } from '../Utils/constants';

const postDatosPago = async (body: MedioPagoReq) => {
  return apiRequest<DatosPago>('post', DATOS_PAGO, body);
};

const getDatosPago = async () => {
  return apiRequest<DatosPago[]>('get', DATOS_PAGO);
};

const getMetodosPago = async () => {
  return apiRequest<MetodoPago[]>('get', GET_PAYMENT);
};

export { postDatosPago, getDatosPago, getMetodosPago };
